
import { Component, Vue } from 'vue-property-decorator'
import { Field } from '@/services/utils/baseForm'
import { popUpRoute } from '@/services/utils/popupRoute'
import { ILocalization } from '@/modules/preference/localization/types/localizationTypes'
import { localizationEndpoints } from '@/modules/preference/localization'
import eventBus from '@/eventBus'
import appStore from '@/AppStore'
import { AnyObject } from '@/shared/types/builtInTypes'
import { ModelApi } from '@/services/api/modelApi'

@Component({
  name: 'ImportLocalization',
  components: {
    BaseForm: () =>
      import(
        /* webpackChunkName : "BaseForm"*/ '@/stories/base-form/BaseForm.vue'
      ),
    DialogBaseSkeleton: () =>
      import(
        /* webpackChunkName : "DialogBaseSkeleton"*/ '@/stories/dialog-base-skeleton/DialogBaseSkeleton.vue'
      )
  }
})
export default class ImportLocalization extends Vue {
  id = this.$route.params.id || ''

  platform = appStore.getters['platform/getPlatformList']
  isDownloading = false

  /**
   * function will be passed to child components
   * @params localization which modules type the fetched localizations will be passed to it in the child component. (base form)
   */
  fields = () => [
    Field.dropdown<ILocalization>(
      'platform',
      'platformId',
      () => Promise.resolve(this.platform),
      (item: AnyObject) => item.name,
      'id'
    )
      .required()
      .setCol('col-12'),
    Field.file<ILocalization>('file', 'uploadLocalizeAttachment')
      .setProps({
        accept: 'text/csv'
      })
      .setRules('ext:csv')
      .required()
      .setCol('col-12')
  ]

  /**
   * submit the data to the desired endpoint.
   */
  async handleSubmit(values: Pick<ILocalization, 'platformId'>) {
    await localizationEndpoints
      .importFile(values.platformId, values)
      .then(() => this.closePopUp())
    eventBus.refreshData()
  }

  /** Download template for the current celery API type */
  async downloadTemplate() {
    try {
      this.isDownloading = true
      // Use ModelApi directly instead of specific endpoints
      const modelApi = new ModelApi('', '')
      await modelApi.downloadTemplate('localization')
    } finally {
      this.isDownloading = false
    }
  }

  closePopUp() {
    popUpRoute.removeModalPath(['id'])
  }
}
